import React from 'react';
import { LeaderBoardMember } from './leader-board-member';
import { LeaderBoardTitle, LeaderBoardWrapper } from './leader-board.styles';
import { sortByRank } from './leader-board.utils';
import { LEADER_BOARD_TITLES, LEADER_BOARD_TOP_USERS_COUNT } from './leader-board.constants';

const defaultProps = {
    loading: false,
    isDesktop: false,
};

interface LeaderBoardProps {
    boardName: string;
    boardData: {
        name: string;
        quantity: number;
    }[];
    loading: boolean;
    isDesktop: boolean;
}

export const LeaderBoard = ({
    boardName, boardData, loading, isDesktop,
}: LeaderBoardProps) => !loading && (
    <LeaderBoardWrapper>
        <LeaderBoardTitle isDesktop={isDesktop}>{LEADER_BOARD_TITLES[boardName]}</LeaderBoardTitle>
        {boardData
            .slice(0, LEADER_BOARD_TOP_USERS_COUNT)
            .sort(sortByRank)
            .map((member, index) => (
                <LeaderBoardMember
                    key={member.name}
                    member={member}
                    rank={index + 1}
                    loading={loading}
                    isDesktop={isDesktop}
                />
            ))}
    </LeaderBoardWrapper>
);

LeaderBoard.defaultProps = defaultProps;
